// 崇明公交在平台上展示的故障码
export const showFaultCode = [
  '2', '31', '81', '91', '128', '129', '133'
]